import { gql } from '@apollo/client'

export const FRAGMENT_MY_BRAND_SOA = gql`
  fragment FragmentMyBrandSoa on MyBrandSoA {
    name
    color
    thumbnail
    id
  }
`
